import { render, staticRenderFns } from "./homeSlave.vue?vue&type=template&id=e6a046ea&scoped=true&"
import script from "./homeSlave.vue?vue&type=script&lang=js&"
export * from "./homeSlave.vue?vue&type=script&lang=js&"
import style0 from "./homeSlave.vue?vue&type=style&index=0&id=e6a046ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a046ea",
  null
  
)

export default component.exports